import { render, staticRenderFns } from "./Factories.vue?vue&type=template&id=30bad5ba"
import script from "./Factories.vue?vue&type=script&lang=js"
export * from "./Factories.vue?vue&type=script&lang=js"
import style0 from "./Factories.vue?vue&type=style&index=0&id=30bad5ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports